export default function ScopeToggle({ value, onChange }) {
  const opts = [["Live", "BAU"], ["Greenfield", "Greenfield"], ["All", "All"]];
  return (
    <div className="inline-flex border border-gray-300 rounded-sm overflow-hidden" data-testid="scope-toggle">
      {opts.map(([v, label]) => (
        <button
          key={v}
          data-testid={`scope-${label.toLowerCase()}`}
          onClick={() => onChange(v)}
          className={`px-3 py-1.5 text-xs font-medium transition-colors duration-200 ${
            value === v ? "bg-[#0E2240] text-white" : "bg-white text-[#6B7280] hover:bg-gray-50"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
